import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { FormattedMessage } from 'react-intl';

interface CancelConfirmationDialogProps {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const CancelConfirmationDialog = ({ show, onConfirm, onCancel }: CancelConfirmationDialogProps) => {
    return (
        <Dialog
            show={show}
            bsSize={Dialog.SIZE_XS}
            showCloseButton={false}
            disableEsc
            title={<FormattedMessage id='intl-msg:smartRoute.tour.cancelConfirmation.title' />}
            body={<FormattedMessage id='intl-msg:smartRoute.tour.cancelConfirmation.message' />}
            footer={
                <div className='display-flex justify-content-end gap-10'>
                    <Button bsStyle={Button.DEFAULT} onClick={onCancel}>
                        <FormattedMessage id='intl-msg:smartRoute.tour.cancelConfirmation.cancel' />
                    </Button>
                    <Button bsStyle={Button.DANGER} onClick={onConfirm}>
                        <FormattedMessage id='intl-msg:smartRoute.tour.cancelConfirmation.confirm' />
                    </Button>
                </div>
            }
        />
    );
};
